import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

// Initialize supabase client with null fallback
let supabase = null;
let initializationError = null;

try {
  if (!supabaseUrl || !supabaseAnonKey) {
    initializationError = 'Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY';
    console.error('Supabase initialization error: Missing environment variables');
  } else {
    // Validate URL format
    try {
      new URL(supabaseUrl);
    } catch (error) {
      initializationError = 'Invalid VITE_SUPABASE_URL format. Please check your .env file.';
      console.error('Invalid Supabase URL format:', supabaseUrl);
      throw new Error(initializationError);
    }

    // Create client with simplified, stable configuration
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    });

    console.log('Supabase client initialized successfully');
  }
} catch (error) {
  console.error('Failed to initialize Supabase client:', error);
  initializationError = error?.message || 'Failed to initialize Supabase client';
}

export { supabase, initializationError };